import { RouteTask } from "domains/scheduling/detail/RouteTask";
import { type RouteComponentProps } from "react-router";

import { routes } from "utilities/routes";

import { type IModalConfiguration } from "commonComponents/btWrappers/BTModal/BTModal";
import { RouteJob } from "commonComponents/entity/job/RouteJob/RouteJob";
import { RouteMediaProperties } from "commonComponents/entity/media/MediaProperties/RouteMediaProperties";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { RouteBid } from "entity/bid/Bid/BidRoute";
import { RouteBidPackage } from "entity/bidPackage/BidPackage/BidPackageRoute";
import { RouteBill } from "entity/bill/Bill/RouteBill";
import { RouteChangeOrder } from "entity/changeOrder/ChangeOrder/ChangeOrderRoute";
import { RouteContact } from "entity/contact/Contact/RouteContact";
import { RouteCostCode } from "entity/costCode/CostCodeDetails/RouteCostCode";
import { RouteCreditMemo } from "entity/creditMemo/CreditMemo/RouteCreditMemo";
import { RouteDeposit } from "entity/deposit/Deposit/RouteDeposit";
import { RouteInternalUser } from "entity/internalUser/InternalUserDetails/RouteInternalUser";
import { RouteLead } from "entity/lead/Lead/LeadRoute";
import { RouteLeadActivity } from "entity/lead/LeadActivity/LeadActivityRoute";
import { RouteLeadProposal } from "entity/leadProposal/LeadProposal/LeadProposalRoute";
import { RouteAllowance } from "entity/legacyAllowance/Allowance/RouteAllowance";
import { RouteMessages } from "entity/message/Message/RouteMessage";
import { RouteMessageCompose } from "entity/message/MessageCompose/MessageComposeRoute";
import { RouteOwnerInvoice } from "entity/ownerInvoice/OwnerInvoice/OwnerInvoiceRoute";
import { RoutePurchaseOrder } from "entity/purchaseOrder/PurchaseOrder/PurchaseOrderRoute";
import { RouteRfi } from "entity/rfi/Rfi/RfiRoute";
import { RouteSchedule } from "entity/schedule/Schedule/RouteSchedule";
import { RouteSelection } from "entity/selection/Selection/SelectionRoute";
import { RouteSelectionChoice } from "entity/selectionChoice/SelectionChoice/SelectionChoiceRoute";
import { RouteSpecification } from "entity/specification/SpecificationRoute";
import { RouteSubVendor } from "entity/sub/SubVendor/RouteSubVendor";
import { RouteToDo } from "entity/toDo/details/ToDoDetails/RouteToDo";
import { RouteWarranty } from "entity/warranty/Warranty/RouteWarranty";

import { useCloseSearchResult } from "./searchResultHistory";

export const SearchBarRoutes: React.FunctionComponent<RouteComponentProps> = (props) => {
    const closeSearchResult = useCloseSearchResult(props.history);

    const modalConfig: IModalConfiguration = {
        beforeClose: () => closeSearchResult(props.match.url),
        parentRoute: props.match.url + routes.search.resultModalPrefix,
    };

    return (
        <RouteRelative
            path={routes.search.resultModalPrefix}
            render={() => (
                <>
                    <RouteToDo modalConfig={modalConfig} />
                    <RouteTask modalConfig={modalConfig} />
                    <RouteContact modalConfig={modalConfig} />
                    <RouteChangeOrder modalConfig={modalConfig} />
                    <RoutePurchaseOrder modalConfig={modalConfig} />
                    <RouteBill modalConfig={modalConfig} />
                    <RouteSubVendor modalConfig={modalConfig} fromSearchResults />
                    <RouteInternalUser modalConfig={modalConfig} />
                    <RouteOwnerInvoice modalConfig={modalConfig} />
                    <RouteMessageCompose isDraft modalConfig={modalConfig} />
                    <RouteMessages modalConfig={modalConfig} />
                    <RouteSchedule modalConfig={modalConfig} />
                    <RouteWarranty modalConfig={modalConfig} />
                    <RouteBidPackage modalConfig={modalConfig} />
                    <RouteBid modalConfig={modalConfig} />
                    <RouteLead modalConfig={modalConfig} />
                    <RouteLeadProposal modalConfig={modalConfig} />
                    <RouteSelection modalConfig={modalConfig} />
                    <RouteSelectionChoice modalConfig={modalConfig} />
                    <RouteRfi modalConfig={modalConfig} />
                    <RouteAllowance modalConfig={modalConfig} />
                    <RouteMediaProperties modalConfig={modalConfig} />
                    <RouteCostCode modalConfig={modalConfig} />
                    <RouteCreditMemo modalConfig={modalConfig} />
                    <RouteDeposit modalConfig={modalConfig} />
                    <RouteLeadActivity modalConfig={modalConfig} />
                    <RouteSpecification modalConfig={modalConfig} />
                    <RouteJob
                        history={props.history}
                        parentRoute={modalConfig.parentRoute}
                        beforeClose={async () => modalConfig.beforeClose()}
                    />
                </>
            )}
        />
    );
};
